import { getBootstrapped } from "core-integration/src/store/bootstrap/reducers";
import {
  getLoginError,
  getPlayerData,
} from "core-integration/src/store/player/reducers";
import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import playerCompLogin from "../../img/player-composite-login-@1x.png";
import playerCompLogin2x from "../../img/player-composite-login-@2x.png";
import { getIsWebView } from "../../utils/webView";
import Alert from "../Alert";
import Copy from "../Copy";
import { D3Login } from "../D3Login";
import {
  ImageFrame,
  Promo,
  PromoHeading,
  PromoImage,
  PromoText,
  TextButtonWrapper,
  TextWrapper,
} from "./styles";

const Login = () => {
  const { t } = useTranslation();
  const player = useSelector(getPlayerData);
  const error = useSelector(getLoginError);
  const bootstrapped = useSelector(getBootstrapped);
  const LOGIN_ERROR = "firebase_loginError";

  // Check if user just completed Firebase auth
  const justAuthenticated =
    sessionStorage.getItem("firebase_authenticated") === "true";

  // Don't show userError if user just authenticated (prevents flash during redirect)
  const userError = justAuthenticated
    ? null
    : localStorage.getItem(LOGIN_ERROR);

  // Clear the flag and any old errors when user just authenticated
  useEffect(() => {
    if (justAuthenticated) {
      // Clear any previous login errors immediately when authenticated
      localStorage.removeItem(LOGIN_ERROR);

      // Clear the authentication flag once player is loaded
      if (player && player.id) {
        sessionStorage.removeItem("firebase_authenticated");
      }
    }
  }, [justAuthenticated, player, LOGIN_ERROR]);

  // If player is logged in, show welcome message
  if (player && player.id) {
    return (
      <div>
        <Copy>
          <p>
            {t("login.loggedInAs", "Welcome back {{firstName}} {{lastName}}", {
              firstName: player.first_name,
              lastName: player.last_name,
            })}
          </p>
        </Copy>
      </div>
    );
  }

  // Don't show error if user just authenticated (player data loading)
  // Only show login error after bootstrap is complete and no player logged in
  if (error && bootstrapped && !justAuthenticated) {
    return (
      <div>
        <Alert type="error">
          {t("login.incorrectDetails", "Incorrect login details")}
        </Alert>
      </div>
    );
  }

  return (
    <>
      {userError && (
        <div>
          <Alert type="error">
            <div>
              {t(
                "login.error.contactSupport",
                "There was a problem with your account, please contact the support team",
              )}
            </div>
            {!getIsWebView() && (
              <div>
                <Trans i18nKey="login.error.a">
                  Please logout and try again.
                </Trans>
              </div>
            )}
          </Alert>
        </div>
      )}
      <Promo>
        <TextButtonWrapper>
          <TextWrapper>
            <PromoHeading>
              {t("login.promo.heading", "Play RSL Fantasy!")}
            </PromoHeading>
            <PromoText>
              {t(
                "login.promo.paragraph",
                "Who really is the best at RSL? Challenge your friends in Fantasy RSL and have the chance to win both honour and great prizes every round!",
              )}
            </PromoText>
          </TextWrapper>
          <D3Login />
        </TextButtonWrapper>
        <ImageFrame>
          <PromoImage
            src={playerCompLogin}
            srcSet={`${playerCompLogin} 1x, ${playerCompLogin2x} 2x`}
            alt=""
          />
        </ImageFrame>
      </Promo>
    </>
  );
};

export default Login;
